export default __webpack_public_path__ + "static/media/icon-checkmark-dark.88c5b66c.svg";